var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Thêm số lượng học sinh",
        width: "520px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-addon-summary" }, [
            _c("div", [
              _c("span", { staticClass: "ps-addon-summary__label" }, [
                _vm._v("Trường"),
              ]),
              _c("strong", [_vm._v(_vm._s(_vm.schoolRow.school.name))]),
            ]),
            _c("div", { staticClass: "ps-addon-summary__numbers" }, [
              _c("span", [
                _vm._v("Đang dùng "),
                _c("b", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatNumber")(_vm.schoolRow.currentStudents)
                    )
                  ),
                ]),
              ]),
              _c("span", [
                _vm._v("Giới hạn hiện tại "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm._f("formatNumber")(_vm.schoolRow.effectiveLimit))
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "addonForm",
          staticClass: "ps-dialog-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Số lượng thêm", prop: "amount", required: "" } },
            [
              _c("el-input-number", {
                staticClass: "ps-full-width",
                attrs: { min: 1, max: 100000, "controls-position": "right" },
                model: {
                  value: _vm.form.amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "amount", $$v)
                  },
                  expression: "form.amount",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "Lý do thêm số lượng",
                prop: "note",
                required: "",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "500",
                  "show-word-limit": "",
                  placeholder: "Nhập lý do thêm số lượng",
                },
                model: {
                  value: _vm.form.note,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "note", $$v)
                  },
                  expression: "form.note",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.schoolRow
        ? _c("div", { staticClass: "ps-addon-after" }, [
            _c("div", [
              _c("span", [_vm._v("Giới hạn hiệu lực sau khi thêm")]),
              _c("b", [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.afterLimit)))]),
            ]),
            _c("div", [
              _c("span", [_vm._v("Tỷ lệ sử dụng mới")]),
              _c(
                "b",
                { class: _vm.afterUsage >= 100 ? "is-danger" : "is-success" },
                [_vm._v(_vm._s(_vm._f("percent")(_vm.afterUsage)) + "%")]
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Hủy")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.handleConfirm },
            },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(
                " Thêm " +
                  _vm._s(_vm.form.amount || 0) +
                  " vào giới hạn số lượng\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }